import { reachedAudioLevelDuringRecording } from '@/lib/analytics/scribe/session';
import { useSessionRecordingStore } from '@/lib/audio/useSessionRecordingStore/useSessionRecordingStore';
import { useAudioLevel } from '@heidi/capture/useAudioLevel';
import { useCurrentSessionId } from '@heidi/runtime/shell';
import { useEffect } from 'react';

const sessionLevels: Map<string, Set<string>> = new Map();

export const useSessionAudioLevelLogging = () => {
  const recordingStatus = useSessionRecordingStore((s) => s.status);
  const sessionId = useCurrentSessionId();
  const audioLevel = useAudioLevel();

  useEffect(() => {
    if (!sessionId || !audioLevel || recordingStatus !== 'RECORDING') return;

    if (!sessionLevels.has(sessionId)) {
      sessionLevels.set(sessionId, new Set());
    }

    const levelsReached = sessionLevels.get(sessionId)!;
    if (levelsReached.has(audioLevel)) return;

    if (audioLevel === 'LOW' || audioLevel === 'NORMAL') {
      levelsReached.add(audioLevel);

      reachedAudioLevelDuringRecording({
        sessionId,
        audioLevel,
      });
    }
  }, [sessionId, audioLevel, recordingStatus]);
};
